import { Anchor, Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import PropTypes from "prop-types";

import quizQueryParams from "@/view/constants/quizQueryParams";
import {
  rootCss,
  tabCss,
  tabTitleCss,
  selectedStateIndicatorCss,
} from "./NavigationTabs.style";

const propTypes = {
  activityPanelQueryParam: PropTypes.string,
  handleTabClick: PropTypes.func,
  levelId: PropTypes.string,
  quizId: PropTypes.quiz,
};

const QUIZ_OVERVIEW_PARAM = quizQueryParams.QUIZ_OVERVIEW_PARAM;
const QUIZ_PREVIEW_PARAM = quizQueryParams.QUIZ_PREVIEW_PARAM;

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const NavigationTabs = ({
  activityPanelQueryParam,
  handleTabClick,
  levelId,
  quizId,
}) => {
  const isOverviewSelected = activityPanelQueryParam === QUIZ_OVERVIEW_PARAM;
  const isPreviewSelected = activityPanelQueryParam === QUIZ_PREVIEW_PARAM;

  const eventProperties = (tab) => ({
    objectType: objectTypes.quiz,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.navigate,
    streamProperties: {
      content_type: "Article",
      description: `Navigate to quiz ${tab} screen`,
      content_id: levelId,
      object_id: quizId,
    },
  });

  const selectedStateIndicator = <div css={selectedStateIndicatorCss} />;

  return (
    <div css={rootCss}>
      <div css={tabCss}>
        <AnchorWithTrackEvent
          __cssFor={{ root: tabTitleCss }}
          onClick={() =>
            handleTabClick({ params: { activityPanel: QUIZ_OVERVIEW_PARAM } })
          }
          styleAnchorAsButton={{
            flavor: Button.flavors.incognito,
          }}
          {...eventProperties("overview")}
        >
          Overview
        </AnchorWithTrackEvent>
        {isOverviewSelected ? selectedStateIndicator : null}
      </div>
      <div css={tabCss}>
        <AnchorWithTrackEvent
          __cssFor={{ root: tabTitleCss }}
          onClick={() =>
            handleTabClick({
              params: { activityPanel: QUIZ_PREVIEW_PARAM, question: 1 },
            })
          }
          styleAnchorAsButton={{
            flavor: Button.flavors.incognito,
          }}
          {...eventProperties("preview")}
        >
          Preview
        </AnchorWithTrackEvent>
        {isPreviewSelected ? selectedStateIndicator : null}
      </div>
    </div>
  );
};

NavigationTabs.propTypes = propTypes;

export default NavigationTabs;
